import type { PropsWithChildren } from 'react'
import { useApplyTheme, useDocumentTitle } from 'hooks'
import GlobalStyles from './GlobalStyles'
import { ToastContainer } from 'components'

export const Initiation = ({ children }: PropsWithChildren) => {
  useApplyTheme()
  useDocumentTitle()

  return (
    <>
      <GlobalStyles />
      <ToastContainer />
      {children}
    </>
  )
}

export default Initiation
